import Badge from 'react-bootstrap/Badge';
import { OrderForListing } from '../../models/OrderForListing';
import { useAuth } from '../../contexts/AuthContext';
import { FormatHelper } from '../../helpers/FormatHelper';
import { SessionHelper } from '../../helpers/SessionHelper';
import { OrderWithPrescriptionEyeGlassesForDifferentPersonsPopover } from './OrderWithPrescriptionEyeGlassesForDifferentPersonsPopover';

interface ICustomerIdentificationCellProps {
  orderForListing: OrderForListing;
}

export const CustomerIdentificationCell: React.FC<ICustomerIdentificationCellProps> = ({
  orderForListing
}) => {

  const { session } = useAuth();
  const canSeeCustomerPhone = SessionHelper.canSeeCustomerPhone(session);

  let customerName = orderForListing.order.customer?.name;

  const customerIdentification = canSeeCustomerPhone && orderForListing.order.customer?.phone ? (
    <span>
        {customerName} <Badge pill bg='info'>{FormatHelper.formatPhone(orderForListing.order.customer?.phone)}</Badge>
      </span>
  ) : (
    <span>
      {customerName}
    </span>
  );

  return <>
    {customerIdentification}
    <OrderWithPrescriptionEyeGlassesForDifferentPersonsPopover orderForListing={orderForListing} />
  </>;
}